import angular from 'angular';

angular.module('cloudX').directive('cxRelationGroupTypeahead', [
  '$filter',
  '$rootScope',
  '$http',
  'appUrls',
  function($filter, $rootScope, $http, appUrls) {
    return {
      restrict: 'E',
      replace: true,
      template: `
        <div class="dropdown"
              uib-dropdown
              ng-show="options.length"
              is-open="ddwOpen">
          <div class="input-group">
            <input type="text"
                   ng-model="selected"
                   uib-typeahead="item as item.name for item in options | filter:{name:\$viewValue} | orderBy:[\'+name\'] | limitTo:limit "
                   typeahead-min-length="0"
                   typeahead-select-on-blur="selectOnBlur"
                   typeahead-select-on-exact="selectOnExact"
                   typeahead-on-select="onSelect(\$item)"
                   ng-blur="onBlur()"
                   ng-focus="ddwOpen=false"
                   class="form-control"
                   placeholder="{{('RelationGroup'|translate)}}"
                   autocomplete="off"
                   data-1p-ignore/>
            <span class="input-group-btn">
              <button class="btn btn-default dropdown-toggle btn-font-14"
                      uib-dropdown-toggle>
                <span class="caret"></span>
              </button>
            </span>
          </div>
          <ul class="dropdown-menu"
              role="menu"
              style="max-height:200px;overflow-y:auto">
            <li ng-repeat="op in options | orderBy:[\'name\']"
              ng-class="{\'selected\':op===selected}">
              <a href ng-click="onSelect(op)">{{op.name}}</a>
            </li>
          </ul>
        </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.options = [];
        $http.get(`${appUrls.api}/api/RelationGroup/GetAll`).then(({ data }) => {
          $scope.options = data;
          $scope.selected = findOption($scope.value);
        });

        $scope.limit = $scope.$eval(attrs.limit) || 10;
        $scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
          : true;
        $scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
          : true;

        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.id === code;
          });
        };

        $scope.onSelect = function(item) {
          $scope.selected = item;
          $scope.value = item.id;
          ngModel.$setViewValue(item.id);
        };
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.value = null;
          $scope.selected = null;
          ngModel.$setViewValue(null);
        };

        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          $scope.selected = findOption($scope.value);
        };
      },
    };
  },
]);
